import postTripConnectData from '../../../data/postTripConnect/postTripConnectData.json';

export const postTripData = postTripConnectData;

export const STATUS_COLORS = {
    new: 'bg-teal-50 text-[#067978] border-teal-100/70',
    contacted: 'bg-teal-50 text-[#067978] border-teal-100/70',
    quoted: 'bg-teal-50 text-[#067978] border-teal-100/70'
};

export const getMilestoneLabel = (milestone) => {
    switch (milestone) {
        case 'custom_bulk':
            return 'Bulk Custom';
        case 'welcome_back':
            return 'Welcome Back';
        case 'feedback_nudge':
            return 'Feedback Nudge';
        default:
            return milestone ? milestone.replace(/_/g, ' ').toUpperCase() : 'Notification';
    }
};

export { format24HourDateTime } from '../../../utils/formatters';
export { formatDisplayDate as format24HourDateOnly } from '../../../utils/formatters';
